import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { Link} from "react-router-dom";
import Logo from '../../images/Mainlogo.png'
import useMediaQuery from "@material-ui/core/useMediaQuery";


const useStyles = makeStyles(theme => ({
  icon: {
    // marginRight: theme.spacing(2),
    height:45,
  },
  title: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: 0
  },
  list: {
    width: 250,
  },
  purpleAvatar: {
    margin: 10,
    color: '#fff',
    backgroundColor: '#171C49',
  },
  avatar: {
    margin: 10,
    color: '#fff',
    // backgroundColor: '#171C49',
  },
}))
export default function Album(props) {
  const matches = useMediaQuery("(min-width:600px)");
 const classes = useStyles();
  
 
  if(matches){
       return (
        <React.Fragment>
        <CssBaseline />
        <AppBar position="fixed"  style={{ background: 'white', boxShadow: 'none'}}>
          <Toolbar>
          <Link >
            <img name="image" src={Logo} alt={"123Mentor"} className={classes.icon} />
          </Link>
            </Toolbar>
          </AppBar>
      </React.Fragment>
  );
}
else{
    return (
    <React.Fragment>
      <CssBaseline />
      <AppBar style={{boxShadow: "none"}}  color="white">
        <Toolbar>
        <Link >
          <img name="image" src={Logo} alt={"123Mentor"} className={classes.icon} />
        </Link>
          <Typography variant="h6" className={classes.title}>
          </Typography>
          </Toolbar>
        </AppBar>
      </React.Fragment>
  );

}
}